import React from 'react';
import { Route } from 'react-router-dom';
import routes from '@/config/routes';
import { PrivateRoute } from './PrivateRoute';
import { Terms } from '@/pages/public/Terms';
import { Privacy } from '@/pages/public/Privacy';
import { ResetPassword, ResetPasswordExpired } from '@/components/auth';
import { PostAuthRedirect } from '@/components/auth/PostAuthRedirect';
import { Login } from '@/components/login';
import MarkAttendance from '@/components/auth/MarkAttendance';
import SpeedTest from '@/components/auth/SpeedTest';

export const getAuthRoutes = (): React.ReactElement[] => {
  const Logout = React.lazy(() => import('@/pages/public/logout'));
  const GigApply = React.lazy(() => import('@/components/auth/GigApply'));
  const NewPassword = React.lazy(() => import('@/components/auth/NewPassword'));
  const StageTwoRedirect = React.lazy(
    () => import('@/components/agent/resume-builder/congratulations/stage-two-redirect'),
  );
  const ServiceProviderDetails = React.lazy(() => import('@/pages/admin/service-providers'));

  const items: React.ReactElement[] = [
    <Route
      key={`auth-${routes.auth.postAuthRedirect}`}
      exact
      path={routes.auth.postAuthRedirect}
      component={PostAuthRedirect}
    />,
    <PrivateRoute key={`auth-${routes.auth.logout}`} path={routes.auth.logout} component={Logout} />,
    <Route key={`auth-${routes.auth.login}`} path={routes.auth.login} render={() => <Login />} />,
    <Route key={`auth-${routes.auth.gigApply}`} exact path={routes.auth.gigApply} component={GigApply} />,
    <Route key={`auth-${routes.auth.markAttendance}`} path={routes.auth.markAttendance} component={MarkAttendance} />,
    <Route key={`auth-${routes.auth.speedTest}`} path={routes.auth.speedTest} component={SpeedTest} />,
    <Route key={`auth-${routes.auth.stageTwo}`} exact path={routes.auth.stageTwo} component={StageTwoRedirect} />,
    <Route
      key={`auth-${routes.auth.newPassword.index}`}
      exact
      path={routes.auth.newPassword.index}
      component={NewPassword}
    />,
    <Route key={`auth-${routes.auth.terms}`} path={routes.auth.terms} render={() => <Terms />} />,
    <Route key={`auth-${routes.auth.privacy}`} path={routes.auth.privacy} render={() => <Privacy />} />,
    <Route
      key={`auth-${routes.auth.resetPassword}`}
      path={routes.auth.resetPassword}
      render={() => <ResetPassword />}
    />,
    <Route
      key={`auth-${routes.admin.agents.serviceProviders}`}
      path={`${routes.admin.agents.serviceProviders}`}
      component={ServiceProviderDetails}
    />,
    <Route
      key={`auth-${routes.auth.privacy}`}
      path={routes.auth.resetPasswordExpired}
      render={() => <ResetPasswordExpired />}
    />,
  ];

  return items;
};
